import { Record } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { class_type, record_type, string_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";

export class DeviceOptionViewModel extends Record {
    constructor(trunk, contralateral, additionalRight, additionalLeft) {
        super();
        this.trunk = trunk;
        this.contralateral = contralateral;
        this.additionalRight = additionalRight;
        this.additionalLeft = additionalLeft;
    }
}

export function DeviceOptionViewModel_$reflection() {
    return record_type("RAWMap.Models.View.DeviceOptionViewModel", [], DeviceOptionViewModel, () => [["trunk", string_type], ["contralateral", string_type], ["additionalRight", string_type], ["additionalLeft", string_type]]);
}

export function DeviceOptionViewModel_get_empty() {
    return new DeviceOptionViewModel("", "", "", "");
}

export class DeviceOptionsViewModel extends Record {
    constructor(studyId, ipsilateralRight, ipsilateralLeft) {
        super();
        this.studyId = studyId;
        this.ipsilateralRight = ipsilateralRight;
        this.ipsilateralLeft = ipsilateralLeft;
    }
}

export function DeviceOptionsViewModel_$reflection() {
    return record_type("RAWMap.Models.View.DeviceOptionsViewModel", [], DeviceOptionsViewModel, () => [["studyId", class_type("System.Guid")], ["ipsilateralRight", DeviceOptionViewModel_$reflection()], ["ipsilateralLeft", DeviceOptionViewModel_$reflection()]]);
}

export function DeviceOptionsViewModel_empty_244AC511(studyId) {
    return new DeviceOptionsViewModel(studyId, DeviceOptionViewModel_get_empty(), DeviceOptionViewModel_get_empty());
}

